import apiClient from '@/services/axios'

export async function put(venueTaskId, venueId, date) {
  console.log(venueTaskId, venueId, date);
  var response = await apiClient.put(`/VenueTasks/setChecked/${venueTaskId}/${venueId}/${date}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to set venue task checked')
}